/**
 * @param boolean
 * @returns {string}
 */
export function booleanToYn(boolean) {
    return boolean ? 'Y' : 'N';
}

/**
 * @param ynString
 * @returns {boolean}
 */
export function ynToBoolean(ynString) {
    return ynString === 'Y';
}

/**
 * @param boolean
 * @returns {number}
 */
export function booleanToDigit(boolean) {
    return boolean ? 1 : 0;
}

/**
 * @param digit
 * @returns {boolean}
 */
export function digitToBoolean(digit) {
    return digit === '1' || digit === 1;
}
